import axios from "axios";
import safeStorage from "./safeStorage";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Single axios instance with credentials — backend sets httpOnly auth_token cookie on login/signup.
// No localStorage = no XSS exfiltration risk.
export const api = axios.create({ baseURL: API, withCredentials: true });
export const apiAuth = api; // alias kept for existing imports

// Attach the Share-My-Concierge referral token (if visitor came in via /share/{token})
// as a header on every request. This is a non-PII fallback for browsers that
// block third-party cookies — the backend uses it to attribute signup +
// booking conversions back to the share record for Owner analytics.
api.interceptors.request.use((config) => {
  // safeStorage transparently handles SSR + private-mode storage failures.
  const shareToken = safeStorage.getWithExpiry("trel_share_token");
  if (shareToken) {
    config.headers = config.headers || {};
    config.headers["X-Trel-Share-Token"] = shareToken;
  }
  return config;
});

// Silently swallow 401 from /auth/me (guest browsing — not an error).
// Catch 403 preview_blocked anywhere and surface the "Sign up to continue" modal globally.
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.config?.url?.endsWith("/auth/me") && e?.response?.status === 401) {
      return Promise.reject({ silent: true });
    }
    if (
      e?.response?.status === 403 &&
      e?.response?.data?.code === "preview_blocked" &&
      typeof window !== "undefined" &&
      typeof window.__trelOpenSignupGate === "function"
    ) {
      window.__trelOpenSignupGate(e.response.data.detail);
    }
    return Promise.reject(e);
  }
);
